export const SET_EXPORT = 'SET_EXPORT';
export const SET_EXPORT_LIST = 'SET_EXPORT_LIST';
export const SET_EXPORT_LAYOUT = 'SET_EXPORT_LAYOUT';
export const SET_PAGE = 'SET_PAGE';
export const RESET_PAGE = 'RESET_PAGE';
export const SET_INDEX_PAGE = 'SET_INDEX_PAGE';
export const UPDATE_LOGO = 'UPDATE_LOGO';
export const UPDATE_COMMENT = 'UPDATE_COMMENT';
